import { ConsultantSetupModal } from "../../onboarding/shared/consultant-setup-modal.tsx";
import { Modal } from "../../../ui/modal/modal.tsx";
import { ItApprovalForm } from "../forms/it-approval-form.tsx";
import type { ItApprovalEmployeeRow } from "../schemas/it-approval-employee.schema.ts";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";

export type ItApprovalModalProps = {
  open: boolean;
  onClose: () => void;
  employee: ItApprovalEmployeeRow | null;
  onSuccess: () => void;
};

export function ItApprovalModal({ open, onClose, employee, onSuccess }: ItApprovalModalProps) {
  const isSqe = useSqeLabs() || employee?.employeeType === "SQELABS";
  if (employee == null) return null;
  if (employee.employeeType === "CONSULTANT" || employee.consultantId != null) {
    return <ConsultantSetupModal key={String(employee.consultantId)} open={open} employee={employee} stage="IT" onClose={onClose} onSuccess={onSuccess} />;
  }

  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={isSqe ? "Create SQE Email" : "Create Caelius Email"} size="xl">
      <ItApprovalForm
        key={`it-approval-${String(employee.id)}`}
        employee={employee}
        onCancel={onClose}
        onSuccess={handleSuccess}
      />
    </Modal>
  );
}
